export default __webpack_public_path__ + "static/media/logo-hpe-on-dark-horizontal.fd3942ec.svg";